// Croqui: `components/CalendarMonth.tsx`, "grade 7x6, dia 32px, range preenchido,
// pontas em amarelo, futuro desativado", que é literalmente o calendário do shadcn já
// instalado (`components/ui/calendar.tsx` sobre `react-day-picker`). Portar a grade à mão
// custaria teclado, foco e semântica de graça. O wrapper só fala em `YYYY-MM-DD`
// (`lib/dates.ts`), que é o que os filtros mandam para a API (`spec/13` §4.1).

import type { DateRange } from 'react-day-picker';
import { cn } from '../../lib/cn.ts';
import { todayIsoDate, toIsoDate } from '../../lib/dates.ts';
import { Calendar } from '../ui/calendar.tsx';

/** Meio-dia local: some com a virada de fuso quando o `Date` volta para `YYYY-MM-DD`. */
export function isoToDate(iso: string): Date {
  const [year, month, day] = iso.split('-').map(Number);
  return new Date(year ?? 1970, (month ?? 1) - 1, day ?? 1, 12);
}

export function dateToIso(date: Date): string {
  return toIsoDate(date);
}

export interface IsoRange {
  from: string;
  to: string;
}

/**
 * Um ou mais meses em modo intervalo. O futuro fica desabilitado: não existe relatório de
 * amanhã.
 */
export function CalendarMonth({
  value,
  onSelect,
  months = 1,
  className,
}: {
  value: IsoRange;
  onSelect: (range: IsoRange) => void;
  months?: number;
  className?: string;
}) {
  const today = todayIsoDate();
  const selected: DateRange = { from: isoToDate(value.from), to: isoToDate(value.to) };

  return (
    <Calendar
      mode="range"
      numberOfMonths={months}
      defaultMonth={isoToDate(value.from)}
      selected={selected}
      disabled={{ after: isoToDate(today) }}
      showOutsideDays={false}
      className={cn('bg-transparent p-0', className)}
      onSelect={(next) => {
        if (next?.from === undefined) {
          return;
        }
        onSelect({ from: dateToIso(next.from), to: dateToIso(next.to ?? next.from) });
      }}
    />
  );
}
